import Share from 'ninelines-sharing';

$('[data-social]')
	.on('click', (event) => {
		let page = location.pathname.slice(1);

		let url = location.origin;

		let social = event.currentTarget.dataset.social;

		if (page) {
			url += `/share.php?page=${encodeURIComponent(page)}`;
		}

		switch (social) {
			case 'facebook':
				Share.facebook(url);
				break;

			case 'vk':
				Share.vk(url);
				break;

			case 'twitter':
				Share.twitter(url);
				break;

			// no default
		}
	});
